import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { ArrowLeft } from 'lucide-react'
import { OrderDetailContent } from './OrderDetailContent'
import type { DeepOrder } from '../types'

interface OrderDetailInlineProps {
  order: DeepOrder
  orderConfirmationEnabled: boolean
  onClose: () => void
  onStatusChange: (orderId: number, status: string) => void
  onCancelOrder: () => void
  onConfirmOrder: () => void
  onDeclineOrder: () => void
  isUpdating?: boolean
  isConfirming?: boolean
  isDeclining?: boolean
}

export function OrderDetailInline({
  order,
  orderConfirmationEnabled,
  onClose,
  onStatusChange,
  onCancelOrder,
  onConfirmOrder,
  onDeclineOrder,
  isUpdating = false,
  isConfirming = false,
  isDeclining = false,
}: OrderDetailInlineProps) {
  const { t } = useTranslation('orders')

  return (
    <div className="space-y-6">
      {/* Back button */}
      <Button
        variant="secondary"
        onClick={onClose}
        className="h-14 px-6 text-lg gap-2 rounded-xl font-semibold"
      >
        <ArrowLeft className="h-5 w-5" />
        {t('kanban.back', 'Zurück')}
      </Button>

      <OrderDetailContent
        order={order}
        orderConfirmationEnabled={orderConfirmationEnabled}
        onStatusChange={onStatusChange}
        onCancelOrder={onCancelOrder}
        onConfirmOrder={onConfirmOrder}
        onDeclineOrder={onDeclineOrder}
        onAfterTimeAction={onClose}
        isUpdating={isUpdating}
        isConfirming={isConfirming}
        isDeclining={isDeclining}
      />
    </div>
  )
}
